import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeEchancier } from '../../../data/Interfaces';
import { filtreListPeriodeMonthYear } from '../DashbordBackOffice';
export const statutEchancier = [
    {
        label:'Payé',
        value:'paye',

    },
    {
        label:'Non payé',
        value:'nonPaye'
    },
    {label:'En attente de paiement',value:'enCours'},
    {label:'Tout',value:'all'}
];

function EchancierExpert({chiffreAffaire,width,height}){

    EchancierExpert.propTypes = {
        chiffreAffaire:PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const [chartDataEchancier, setChartDataEchancier] = useState({
        series: [],

        options: {
            labels: [],
            chart: {
                type: 'bar',
                zoom: {
                    enabled: true,
                    //type: 'xy', // Use 'xy' for 2D zoom (x and y-axis) or 'y' for only y-axis zoom
                },
            },
            bar : {
                columnWidth: '50px',
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '15%', // Set the desired bar width as a percentage of the available space
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                position: 'bottom',
                offsetY: 40
            },
            fill: {
                opacity: 1,
            },
        },
    });

    const [selectedStatutchancier, setSelectedStatutchancier] = useState('all'); // Default selected period
    const [selectedPeriod, setSelectedPeriod] = useState('custom'); // Default selected period
    const { i18n } = useTranslation();
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 2);

    const [customDateRange, setCustomDateRange] = useState({
        from: currentDate.toISOString().slice(0, 10), // Get formatted date
        to: new Date().toISOString().slice(0, 10), // Get current date in YYYY-MM-DD format
    });

    useEffect(()=>{
        if(Array.isArray(chiffreAffaire)){
            //const firstFiltrePeriode=filtreListPeriode(allStatusMissions,selectedPeriodMission,customDateRangeMission);
            var filteredData;
            filteredData=chiffreAffaire;
            if (selectedStatutchancier != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.statutPaiementCalculated == selectedStatutchancier
                );
            }

            if(selectedPeriod)
                filteredData=filtreListPeriodeMonthYear(filteredData,selectedPeriod,customDateRange);

            console.log('chiffreAffaire',filteredData);
            const {periodes,backofficeArrays}=calculateCAByPeriodeAndEchancier(filteredData);

            setChartDataEchancier((prevState) => {
                return {
                    ...prevState,
                    series:statutEchancier.map((office, index) => ({
                        name: office.label,
                        data: backofficeArrays[index],
                    })),
                    options: {
                        ...prevState.options,
                        xaxis: {
                            ...prevState.options.xaxis,
                            categories: periodes
                            //Object.keys(counts)
                            //Array.isArray(CountsListStatusCandidatures) ? CountsListStatusCandidatures.map((item) => item.date) : [],
                        },
                    },
                };
            });
        }
    },[chiffreAffaire,selectedStatutchancier]);

    const groupData = (data,filtreItem) => {
        let key2;
        let result={};
        data.map((item) => {
            const { periode, totalHtExpert } = item;
            if (filtreItem === 'backOffice') {
                key2 = item.backOfficeId;
            } else {
                key2 = item.statutPaiementCalculated;
            }

            if (!result[periode]) {
                result[periode] = {};
            }
            if (!result[periode][key2]) {
                result[periode][key2] = 0;
            }
            result[periode][key2] += totalHtExpert;
        });
        console.log('groupedData',result);
        return result;
    };

    const calculateCAByPeriodeAndEchancier = (data) => {
        const groupedData = groupData(data,'statutPaiementEchancier');
        // Construct the final arrays for each periode
        const periodes = Object.keys(groupedData);
        const backofficeArrays = statutEchancier.slice(0,-1).map(({ value }) =>
            periodes.map((periode) => groupedData[periode][value]?.toFixed(2) || 0)
        );
        return {periodes,backofficeArrays};
    };

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Echéancier')}</h1>
                <div className='filtre1'>
                    <div style={{width:'30%'}}>
                        <SelectComponent
                            label='Statut échéancier'
                            val={selectedStatutchancier}
                            name='Statut échéancier'
                            setVal={(e) => {
                                setSelectedStatutchancier(e.target.value);
                            }}
                            listVal={statutEchancier}
                        />
                    </div>
                    <div style={{width:'25%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriod}
                            setSelectedPeriod={setSelectedPeriod}
                            setCustomDateRange={setCustomDateRange}
                            listeVal={PeriodeEchancier}

                        />
                    </div>
                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataEchancier.options}
                        series={chartDataEchancier.series}
                        type="bar"
                        width={'100%'}
                        height={'75%'}
                    />
                </div>
            </div>
        </>
    );

}
export default EchancierExpert;